import React, {useEffect, useReducer, useState} from "react";
import {ReportData, BasicRow, ReportRet, ColDesc} from "./ReportDisplayTypes"
import { Table } from "react-bootstrap";
import "./ReportDisplay.css"

interface colType{
    title: string
    type: string
    id: number
    titleRow: number
}
function ReportDisplay(props: {ReportData: ReportRet}){
    //Table data
    const [data, setData] = useState<BasicRow[]>([])
    //Titles of table
    const [title, setTitle] = useState("")
    const [subTitle, setSubTitle] = useState("")
    //Table column descriptors
    const [columns, setColumns] = useState<colType[]>([])
    //Number of rows in table header
    const [colTitleRows, setColTitleRows] = useState(0)

    //used to update table data when prop data changes
    useEffect(()=>{
        //checks to see if data exists
        if(props.ReportData.ReportData != undefined){
            //sets table titles
            setTitle(props.ReportData.ReportTitle)
            setSubTitle(props.ReportData.ReportSubtitle)
            //sets table column descriptions
            var columns = [] as colType[]
            props.ReportData.ColDesc?.forEach((x:ColDesc) => {
                const column = {
                    title: x.ColTitle.value,
                    type: x.ColType,
                    id: x.colID,
                    titleRow: x.ColTitle.titleRow
                }
                columns.push(column)
            })
            //sorts columns by id
            columns.sort((a,b) => a.id>b.id?1:-1)
            setColumns(columns)
            setColTitleRows(props.ReportData.NumColTitleRows)
            //gathers all data from row data
            var data = [] as BasicRow[]
            if(props.ReportData.ReportData.TotalRow){
                data = [...data, ...props.ReportData.ReportData.TotalRow]
            }
            if(props.ReportData.ReportData.DataRow){
                data = [...data, ...props.ReportData.ReportData.DataRow]
            }
            if(props.ReportData.ReportData.SubtotalRow){
                data = [...data, ...props.ReportData.ReportData.SubtotalRow]
            }
            if(props.ReportData.ReportData.TextRow){
                data = [...data, ...props.ReportData.ReportData.TextRow]
            }
            //sorts data by row id
            data.sort((a,b) => a.rowNumber>b.rowNumber?1:-1)
            setData(data)
        }
        
    }, [props.ReportData])

    return(
        <div className="ReportDisplayQB">
            <div className="tableTitleQB">
                <b>{title}</b>
            </div>
            <div className="tableSubTitleQB">
                <p>{subTitle}</p>
            </div>
            <div className="ReportTableQB">
                <Table>
                    <thead>
                        {
                            [...Array(colTitleRows)].map((e, i) => {
                                var row = columns.filter(x => x.titleRow === i+1 )
                                return(
                                    <tr key={i}>
                                        {
                                            row.map(j => (
                                                <th key={j.id}>
                                                    {j.title}
                                                </th> 
                                            ))
                                        }
                                    </tr>
                                )
                            })
                        }
                    </thead>
                    <tbody>
                        {
                            data.map((i) => (
                                <tr key={i.rowNumber}>
                                    {
                                        Object.keys(i).find(x => x==="value")?
                                        <>                     
                                            <td className="textRowQB" colSpan={columns.length}>
                                                {i.value}
                                            </td> 
                                        </>:
                                        Object.keys(i).find(x => x==="ColData")?
                                        <>
                                            
                                            {
                                                i.ColData!==undefined?
                                                columns.map(x => {
                                                    var col = i.ColData?.find(y => y.colID===x.id) ?? {value: ""}
                                                    return(
                                                        <td key={x.id}>
                                                            {col.value}
                                                        </td>
                                                    )
                                                })
                                            :null}
                                        </>:null
                                    }
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default ReportDisplay